import {EntityModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {ProductBarcodeData} from "./product-barcode.data";

@Injectable()
export class ProductBarcodeEntityModel extends EntityModel<ProductBarcodeData> {
    constructor(injector: Injector) {
        super(injector, ProductBarcodeData);
    }

    override canCreateEntity(): Promise<boolean> {
        return Promise.resolve(false);
    }
}
